import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const WebDevelopmentJobsNoida = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`Web Development Jobs in Noida | Latest Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Explore the latest Web Development Jobs in Noida NCR. Find openings for Frontend, Backend, and Full Stack Web Developers. Apply now at JobsInDelhiNCR."
        />
        <meta
          name="keywords"
          content="web development jobs in Noida, frontend developer jobs Noida, backend developer jobs Noida, full stack web developer jobs Noida, HTML CSS JavaScript jobs Noida, React developer jobs Noida, Node.js developer jobs Noida, web designer jobs Noida NCR, fresher web developer jobs Noida, web developer openings Noida NCR"
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://jobsindelhincr.in/webdevelopment-jobs-in-noida"
        />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Web Development Jobs in Noida – Latest Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Looking for the latest <strong>Web Development Jobs in Noida NCR</strong>? Whether you're a frontend, backend, or full stack web developer, explore verified opportunities across top companies and startups hiring in Noida NCR.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring Web Developers in Noida
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Accenture</li>
          <li>Wipro</li>
          <li>Infosys</li>
          <li>HCL</li>
          <li>Tech Mahindra</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Popular Web Developer Roles in Noida
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Frontend Developer Jobs in Noida</li>
          <li>Backend Developer Jobs in Noida</li>
          <li>Full Stack Developer Jobs in Noida</li>
          <li>React Developer Jobs in Noida</li>
          <li>Node.js Developer Jobs in Noida</li>
          <li>PHP Developer Jobs in Noida</li>
          <li>JavaScript Developer Jobs in Noida</li>
          <li>Web Designer Jobs in Noida</li>
          <li>HTML/CSS Developer Jobs in Noida</li>
          <li>WordPress Developer Jobs in Noida</li>
        </ul>

        <p className="text-gray-600">
          Kickstart your career with <strong>jobsindelhincr.in</strong> — your trusted job portal to find verified <strong>Web Development Jobs in Noida NCR</strong>. No registration required – apply directly and start working with the best companies today.
        </p>
      </div>

      <Footer />
    </>
  );
};

export default WebDevelopmentJobsNoida;
